module.exports = __webpack_public_path__ + "static/media/eligibilityLetter.b9e57941.svg";